import { clearDeviceId, dropLocalSubscription } from "../../../shared/lib/push";
import { notificationApi } from "../api/service";

/** The axios instance carries no global timeout, so this call bounds itself. */
const UNSUBSCRIBE_TIMEOUT_MS = 3000;

/**
 * Unregisters this device on the way out of a session.
 *
 * A plain function rather than a hook, because logging out is not a render.
 *
 * Three things matter here. It must run **before** the auth cookie is cleared, or the request
 * 401s. It must never throw: a phone that keeps a stale row is a nuisance the next 410 cleans
 * up by itself. And it must never hang: `logout()` awaits this before clearing auth state, so
 * an unbounded request on a dead network would block the user's sign-out indefinitely — the
 * timeout race below is what keeps that a real bound instead of a comment.
 */
export async function detachPushDevice(): Promise<void> {
  try {
    const endpoint = await dropLocalSubscription();
    if (endpoint) {
      await Promise.race([
        notificationApi.unsubscribe({ endpoint }),
        new Promise((resolve) => setTimeout(resolve, UNSUBSCRIBE_TIMEOUT_MS)),
      ]);
    }
  } catch {
    // Deliberately silent. See above.
  } finally {
    clearDeviceId();
  }
}
